<div class="modal-header">
    <h5 class="modal-title w-100">
        <div class="alert-icon d-flex justify-content-center mb-4">
            <img src="/assets/images/alert.png" height="70px" width="auto" />
        </div>
        <p class="text d-block text-center">{{title || 'N/A'}}</p>
    </h5>
    <span *ngIf="closeBtn" class="fa fa-close" aria-label="Close" (click)="activeModal.close('close')"></span>
</div>
<div class="modal-body w-100 text-center">
    <div>
        <p class="text m-0">{{message1 || 'N/A'}}</p>

    </div>

</div>
<div class="modal-footer w-100 d-flex flex-column">
    <div class="w-100 action-buttons d-flex align-items-center justify-content-end gap-1">
        <button type="button" class="btn btn-primary" (click)="activeModal.close('cancel')">{{no_label ||
            'NO'}}</button>
    </div>
</div>